import { Transaction } from '../generated/graphql'

export const transactionOrderCategories = (
    transaction: Transaction | undefined
) => {
    return (
        transaction?.payment?.category ||
        (transaction?.order?.rows || []).map((o) => o.category).join(', ') ||
        transaction?.contribution?.category
    )
}
